import React from 'react';

import type { TooltipStatefulProps } from '../../Tooltip';
import { TooltipStateful } from '../../Tooltip';

export type TextWrapperProps = {
    hasTooltip?: boolean;
    tooltipProps: Omit<TooltipStatefulProps, 'children'>;
    children: React.ReactElement;
};

export const TextWrapper: React.FC<TextWrapperProps> = (props) => {
    const { hasTooltip, tooltipProps, children } = props;

    if (hasTooltip) {
        return <TooltipStateful {...tooltipProps}>{children}</TooltipStateful>;
    }

    return children;
};
